import React, { useRef, useState } from "react";
import YuJaButton from "../../components/standardization/YuJaButton";
import { YuJaTextBox } from "../../components/standardization/YuJaTextBox";
import useMobileAccess from '../../hooks/useMobileAccess';
import { ReactComponent as SearchIcon } from "../../images/search_bar_icon.svg";
import {
    ATTENDANCE,
    BUTTON,
    DRAFT_TEXT,
    MERGED_MODE,
    POLL_TEXT,
    READY_TO_SHARE,
    SCHEDULED,
    SHARED_BY_QUESTION,
    SHARED_ENTIRELY,
} from '../../utils/constants';
import { notifyError } from '../../utils/helpers';
import { useTranslation } from "react-i18next";
import styles from "./ManagePolls.module.css";
import "./styles.css";
import FilterMenuNew from "../../components/FilterMenuNew";
import classes from "../ReleaseActivityPage/ReleaseActivityPage.module.css";

export default function PollSearchForm({handleSubmit, disabled=false, collapsed=false, isPPT=false, filter={}, setSelectedPoll}) {
    const { t } = useTranslation();
    const isNarrow = useRef(useMobileAccess(1200));
    // const windowDimensions = useWindowDimensions();
    const [keyword, setKeyword] = useState(!!filter.keyword ? filter.keyword : "");
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [startDate, setStartDate] = useState(!!filter.startDate ? filter.startDate : "");
    const [endDate, setEndDate] = useState(!!filter.endDate ? filter.endDate : "");
    const [modeFilter, setModeFilter] = useState(!!filter.mode ? filter.mode : (isPPT ? [POLL_TEXT] : []));
    const [statusFilter, setStatusFilter] = useState(!!filter.status ? filter.status : []);
    // const [smallScreen, setSmallScreen] = useState(window.innerWidth < 1200);



    const clickSearch = ({key=keyword, start=startDate, end=endDate, mode=modeFilter, status=statusFilter}) => {
        if (disabled) {
            notifyError(t("poll.loadingSearchError"));
            return;
        }
        let formattedStartDate = start ? start.split("-").reverse().join("-") : "";
        let formattedEndDate = end ? end.split("-").reverse().join("-") : "";
        handleSubmit({
            keyword: key,
            startDate: formattedStartDate,
            endDate: formattedEndDate,
            mode: mode,
            status: status
        });
    };

    const enterKeyup = (e) => {
        if (e.key === 'Enter') {
            clickSearch({});
        }
    }


    const onApply = (filterOptions) => {
        if (isPPT) {
            // setModeFilter(filterOptions.optionFilter1);
            setStatusFilter(filterOptions.optionFilter1);
            setStartDate(filterOptions.dateFilter1);
            setEndDate(filterOptions.dateFilter2);
            clickSearch({
                start: filterOptions.dateFilter1,
                end: filterOptions.dateFilter2,
                mode: modeFilter,
                status: filterOptions.optionFilter1
            });
        } else {
            setModeFilter(filterOptions.optionFilter1);
            setStatusFilter(filterOptions.optionFilter2);
            setStartDate(filterOptions.dateFilter1);
            setEndDate(filterOptions.dateFilter2);
            clickSearch({
                start: filterOptions.dateFilter1,
                end: filterOptions.dateFilter2,
                mode: filterOptions.optionFilter1,
                status: filterOptions.optionFilter2
            });
        }

    };

    return (
        <div style={{width: "100%", display: "flex", alignItems: "center"}}>

            {isPPT &&
                <>
                    <div className={classes.cardTabContainer}>
                        <span
                            tabIndex={0}
                            role={BUTTON}
                            onClick={() => {
                                if (!modeFilter.includes(POLL_TEXT)) {
                                    setSelectedPoll({});
                                }

                                setModeFilter([POLL_TEXT]);
                                clickSearch({
                                    start: startDate,
                                    end: endDate,
                                    mode: [POLL_TEXT],
                                    status: statusFilter
                                });
                            }}
                            className={`${classes.cardTab} ${modeFilter.includes(POLL_TEXT) ? classes.active : ""}`}
                        >
                            {t("poll.mergedModeText")}
                        </span>
                        <span
                            tabIndex={0}
                            role={BUTTON}
                            onClick={() => {
                                if (!modeFilter.includes(ATTENDANCE)) {
                                    setSelectedPoll({});
                                }
                                setModeFilter([ATTENDANCE]);
                                clickSearch({
                                    start: startDate,
                                    end: endDate,
                                    mode: [ATTENDANCE],
                                    status: statusFilter
                                });
                            }}
                            className={`${classes.cardTab} ${modeFilter.includes(ATTENDANCE) ? classes.active : ""}`}
                        >
                            {t("poll.attendanceLabel")}
                        </span>
                    </div>
                    <div style={{width: 70, flexShrink: 1}}/>
                </>
            }

            <div className={styles.searchBox}>
                <FilterMenuNew
                    show={showFilterMenu}
                    setShow={setShowFilterMenu}
                    onApply={onApply}
                    filterOptions={
                    isPPT
                        ? {
                            // optionFilter1Name: POLL_TYPE_HEADER,
                            // optionFilter1: modeFilter,
                            // optionsFilter1: [MERGED_MODE, ATTENDANCE],
                            optionFilter1Name: t("common.statusLabel"),
                            optionFilter1: statusFilter,
                            optionsFilter1: modeFilter.includes(POLL_TEXT)
                                ? [DRAFT_TEXT, READY_TO_SHARE, SHARED_BY_QUESTION, SHARED_ENTIRELY]
                                : [READY_TO_SHARE, SHARED_ENTIRELY],
                            dateFilter1Name: t("poll.startDateLabel"),
                            dateFilter1: startDate,
                            dateFilter2Name: t("poll.endDateLabel"),
                            dateFilter2: endDate
                        }
                        : {
                            optionFilter1Name: t("common.typeLabel"),
                            optionFilter1: modeFilter,
                            optionsFilter1: [MERGED_MODE, ATTENDANCE],
                            optionFilter2Name: t("common.statusLabel"),
                            optionFilter2: statusFilter,
                            optionsFilter2: [DRAFT_TEXT, READY_TO_SHARE, SHARED_BY_QUESTION, SHARED_ENTIRELY, SCHEDULED],
                            dateFilter1Name: t("poll.startDateLabel"),
                            dateFilter1: startDate,
                            dateFilter2Name: t("poll.endDateLabel"),
                            dateFilter2: endDate
                        }
                    }
                    isPPT={isPPT}
                />

                <YuJaTextBox
                    label={t("accessibility.searchPollTextbox")}
                    containerStyle={{fontSize: 14, lineHeight: 1.6, flex: 1, height: 40}}
                    placeholder={t("report.courseTableSearchPlaceholder")}
                    onChange={e => setKeyword(e.target.value)}
                    onKeyUp={enterKeyup}
                    value={keyword}
                    before={<SearchIcon style={{marginRight: 5, width: 16}}/>}
                />

                <YuJaButton onClick={clickSearch} style={{height: 40, minWidth: 80, flexShrink: 0, fontSize: 14, lineHeight: 1.6,}}>{t("common.search")}</YuJaButton>
            </div>
        </div>
    );
}